// extracted by mini-css-extract-plugin
export default {"container":"GoBackButton_container__oZ-B5","wide":"GoBackButton_wide__-8bhl","icon":"GoBackButton_icon__PyJb8"};